import { z } from 'zod';
import { FlowDefinitionTemplateTagSchema } from './flowDefinitionTemplate.js';
import { FlowDefinitionTemplateMetadataSchema } from './metadata.js';
import { FlowDefinitionTemplateVisibility } from './visibility.js';
/**
 * Body `POST /flow-definition-templates` accepts.
 *
 * A template is a published view of a flow definition that already exists, so the source is named
 * rather than sent: the graph itself is never part of this request.
 */
export const FlowDefinitionTemplateCreateBodySchema = z.object({
    organizationId: z.uuid().describe('Organization the template belongs to.'),
    name: z.string(),
    sourceFlowDefinitionId: z.uuid().describe('Flow definition the template publishes.'),
    content: z.string().describe('Short summary shown in the library.').optional().default(''),
    detailedContentMarkdown: z.string().describe('Long description.').optional().default(''),
    tags: z.array(FlowDefinitionTemplateTagSchema).optional().default([]),
    visibility: z
        .enum(FlowDefinitionTemplateVisibility)
        .optional()
        .default(FlowDefinitionTemplateVisibility.Global),
    metadata: FlowDefinitionTemplateMetadataSchema.optional().default({}),
});
/**
 * Body `PATCH /flow-definition-templates/{id}` accepts.
 *
 * Derived from a shape carrying no defaults, so a field left out of a patch stays out rather than
 * arriving as an empty string and overwriting what is stored. The source definition is absent: a
 * template that published a different flow would be a different template.
 */
export const FlowDefinitionTemplateUpdateBodySchema = FlowDefinitionTemplateCreateBodySchema.omit({
    sourceFlowDefinitionId: true,
})
    .extend({
    content: z.string(),
    detailedContentMarkdown: z.string(),
    tags: z.array(FlowDefinitionTemplateTagSchema),
    visibility: z.enum(FlowDefinitionTemplateVisibility),
    metadata: FlowDefinitionTemplateMetadataSchema,
})
    .partial();
/** Body the endpoints adding or removing one tag accept. */
export const FlowDefinitionTemplateTagBodySchema = z.object({
    tag: FlowDefinitionTemplateTagSchema,
});
/** An image sent inline, base64 encoded, rather than as a file upload. */
const FlowDefinitionTemplateImageContentTypeSchema = z
    .string()
    .startsWith('image/', { message: 'Content type must be an image' });
/** Body `POST /flow-definition-templates/{id}/thumbnail` accepts. */
export const FlowDefinitionTemplateThumbnailBodySchema = z.object({
    thumbnailData: z.string().describe('The image, base64 encoded.'),
    contentType: FlowDefinitionTemplateImageContentTypeSchema,
});
/** Body `POST /flow-definition-templates/{id}/case-study-image` accepts. */
export const FlowDefinitionTemplateCaseStudyImageBodySchema = z.object({
    caseStudyImageData: z.string().describe('The image, base64 encoded.'),
    contentType: FlowDefinitionTemplateImageContentTypeSchema,
});
//# sourceMappingURL=requests.js.map